import { assetUrl } from './assetUrl';

/**
 * Banderas locales (mismo origen que el CDN del webapp).
 * flagcdn.com no carga en WebView2 ingame — red externa bloqueada.
 */
export function flagUrl(countryCode: string): string {
  const code = countryCode.toLowerCase().replace(/[^a-z]/g, '');
  return assetUrl(`/assets/flags/${code}.svg`);
}
